<template>
  <div class="dropdown inline-block relative">
    <div v-if="!authenticated">
      <router-link to="/login">
        <button
          type="button"
          class="
            text-white
            bg-blue-700
            hover:bg-blue-800
            focus:ring-4 focus:ring-blue-300
            font-semibold
            rounded-lg
            text-base
            px-6
            py-2
            text-center
            mr-3
            md:mr-0
            dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800
            inline-flex
            items-center
            w-24
            align-middle
          "
        >
          <span class="mr-0">Log in</span>
        </button>
      </router-link>
      <ul class="dropdown-menu absolute hidden text-gray-700">
        <li class="pt-2">
          <router-link to="/register">
            <button
              data-collapse-toggle="mobile-menu-4"
              type="button"
              class="
                block
                font-semibold
                rounded-lg
                items-center
                text-base
                px-4
                py-2
                text-white
                hover:bg-gray-100
                bg-blue-700
                focus:outline-none focus:ring-2 focus:ring-gray-200
                dark:text-white dark:hover:bg-blue-800 dark:focus:ring-gray-600
                whitespace-no-wrap
                w-24
              "
            >
              Register
            </button>
          </router-link>
        </li>
      </ul>
    </div>
    <div v-else>
      <router-link to="/create">
        <button
          type="button"
          class="
            block
            font-semibold
            rounded-lg
            items-center
            text-base
            py-2
            text-white
            hover:bg-gray-100
            bg-blue-700
            focus:outline-none focus:ring-2 focus:ring-gray-200
            dark:text-white dark:hover:bg-blue-800 dark:focus:ring-gray-600
            whitespace-no-wrap
            w-24
          "
        >
          <span class="mr-0">Create</span>
        </button>
      </router-link>
      <ul class="dropdown-menu absolute hidden text-gray-700">
        <li class="pt-2">
          <router-link to="/login">
            <button
              data-collapse-toggle="mobile-menu-4"
              type="button"
              class="
                text-white
                bg-red-700
                hover:bg-red-800
                focus:ring-4 focus:ring-blue-300
                font-semibold
                rounded-lg
                text-base
                px-4
                py-2
                text-center
                mr-3
                md:mr-0
                dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800
                inline-flex
                items-center
                w-24
                align-middle
              "
              v-on:click="logout"
            >
              Log Out
            </button>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from "../store";
import axios from "axios";
export default {
  name: "LoginButton",
  data() {
    return {};
  },
  methods: {
    logout() {
      store.dispatch("setLastPostTime", Date.parse("2000-01-01"));
      var config = {
        method: "get",
        url: "http://138.197.71.184:5001/logout",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          store.dispatch("setAuthenticated", false);
          store.dispatch("setUserData", null);
          store.dispatch("setSuccess", "Log out succesfully");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  computed: {
    authenticated() {
      return store.getters.authenticated;
    },
  },
};
</script>

<style>
.dropdown:hover .dropdown-menu {
  color: black;
  display: block;
}
</style>